import { ERRORS } from './constants';
import { JoinTeamAccountsV2ErrorCode } from '../../types/GloblalTypes';
export var mapJoinTeamAccountsErrorToPageError = function (joinTeamAccountsV2Error) {
    var pageErrorCode;
    switch (joinTeamAccountsV2Error === null || joinTeamAccountsV2Error === void 0 ? void 0 : joinTeamAccountsV2Error.code) {
        case JoinTeamAccountsV2ErrorCode.ALREADY_ACTIVE:
            pageErrorCode = ERRORS.existingMealBenefits;
            break;
        case JoinTeamAccountsV2ErrorCode.DIFFERENT_TEAM:
            pageErrorCode = ERRORS.tryADifferentAccount;
            break;
        case JoinTeamAccountsV2ErrorCode.WRONG_PENDING_MEMBER_ID:
            pageErrorCode = ERRORS.invalidInviteLink;
            break;
        case JoinTeamAccountsV2ErrorCode.INVALID_PENDING_MEMBER_ID:
            pageErrorCode = ERRORS.invalidInviteLink;
            break;
        case JoinTeamAccountsV2ErrorCode.PERSONAL_LOGIN_IS_DISABLED:
            pageErrorCode = ERRORS.useCompanyEmail;
            break;
        case JoinTeamAccountsV2ErrorCode.INTERNAL_ERROR:
            pageErrorCode = ERRORS.somethingWentWrong;
            break;
        case JoinTeamAccountsV2ErrorCode.UNSPECIFIED:
            pageErrorCode = ERRORS.somethingWentWrong;
            break;
        default:
            pageErrorCode = ERRORS.somethingWentWrong;
    }
    return pageErrorCode;
};
